import { render, staticRenderFns } from "./academico-el.vue?vue&type=template&id=14531caf"
import script from "./academico-el.vue?vue&type=script&lang=js"
export * from "./academico-el.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports